var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronLeftBlack = function SvgChevronLeftBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 44 44"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "chevron-left-black_svg__a",
    d: "M0 0h44v44H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "rotate(-180 22 22)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "chevron-left-black_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#chevron-left-black_svg__a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    mask: "url(#chevron-left-black_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.586 9.272 18 7.858 32.142 22l-1.414 1.414z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.728 20.586 32.142 22 18 36.142l-1.414-1.414z"
  })))));
};
export default SvgChevronLeftBlack;